import { Fragment } from 'react';

import { SkeletonParagraph } from '../../../components/common';
import { ESkeletonKind } from '../../../components/common/Skeleton/skeletonTypes';

const renderParam = () => (
    <Fragment>
        <SkeletonParagraph
            className="order__block"
            kind={ESkeletonKind.PARAGRAPH_SMALL}
        />
        <SkeletonParagraph
            className="order__block"
            kind={ESkeletonKind.PARAGRAPH_SMALL}
            style={{ width: 300 }}
        />
    </Fragment>
);

export const OrderIdSkeleton = () => (
    <Fragment>
        <SkeletonParagraph
            className="order__block"
            kind={ESkeletonKind.BUTTON_ROUND}
            style={{ marginTop: 24, marginBottom: 32, width: 300 }}
        />
        <div className="order__info" style={{ marginBottom: 32 }}>
            <SkeletonParagraph
                className="order__block"
                kind={ESkeletonKind.BUTTON_ROUND}
                style={{ marginBottom: 24, width: 500 }}
            />
            {renderParam()}
        </div>
        <div className="order__parameters">
            {renderParam()}
            {renderParam()}
            {renderParam()}
        </div>
    </Fragment>
)
